import { getApplicantRequest, getGroupApplicantsRequest, updateApplicantKey, updateGroupApplicantAnswer, setApplicantNeedAttention, setLastProctoringActivity, setApplicantProctoringHandles, stopApplicantProctoring, setProctorAudioActive } from './ApplicantActions';
import { getApplicantAnswersRequest, setAnswers, setApplicantAnswers } from '../Answer/AnswerActions';
import { getApplicantFlagsRequest } from '../Flag/FlagActions';
import { setRedirect } from '../App/AppActions';
import { addError } from '../Error/ErrorActions';

// Applicant
export default function socketListner(socket, dispatch, intl, getUser = () => null) {
    // Applicant edited => refresh applicants list
    socket.on('applicant/edited', data => {
        console.log('Socket::: applicant/edited received', data);
        dispatch(getApplicantRequest(data.applicant));
    });

    // Applicant edited => refresh group applicants
    socket.on('group/applicant/edited', data => {
        dispatch(getGroupApplicantsRequest(data.applicant));
    });

    // Applicant edited => refresh session applicants list for adminsitrators
    socket.on('session/applicant/edited', data => {
        if(!['student'].includes((getUser() || {}).role)) {
            // dispatch(getSessionApplicantsRequest(data.session));
            dispatch(getApplicantRequest(data.applicant, false, data.user));
        }
    });

    // Applicant has accessed to his session (parallel access ??)
    socket.on('applicant/accessed', data => {
        if(data.applicant && ['student'].includes((getUser() || {}).role)) {
            dispatch(addError('ApplicantSessionParallelAccessError', 'warning'));
            dispatch(setRedirect('/'));
        }
    });

    // Applicant updated => refresh applicants list
    socket.on('applicant/updated', data => {
        if(data.applicant && data.updates) {
            data.updates.forEach(update => {
                dispatch(updateApplicantKey(data.applicant, update.key, update.value, data.session));
            });
        }
    });

    // Applicant updated => refresh group applicants
    socket.on('group/applicant/updated', data => {
        if(data.applicant && data.updates) {
            data.updates.forEach(update => {
                dispatch(updateApplicantKey(data.applicant, update.key, update.value, data.session));
            });
        }
    });

    // Applicant updated => refresh session applicants list for adminsitrators
    socket.on('session/applicant/updated', data => {
        if(!['student'].includes((getUser() || {}).role)) {
            if(data.applicant && data.updates) {
                data.updates.forEach(update => {
                    dispatch(updateApplicantKey(data.applicant, update.key, update.value, data.session));
                });
            }
        }
    });

    // Applicant saved (in case of sendToApplicant is true) => refresh applicant answers
    socket.on('applicant/saved', data => {
        // Update applicants answers
        dispatch(getApplicantAnswersRequest(data.applicant));
    });

    // Group applicants saved an answer => refresh group answers
    socket.on('group/applicant/saved', data => {
        // Update other group applicants answers
        dispatch(updateGroupApplicantAnswer(data.applicant, data.answers));
    });

    // Applicant saved an answer =>  Update applicant answers for administrators
    socket.on('session/applicant/saved', data => {
        if(!['proctor', 'student'].includes((getUser() || {}).role)) {
            // dispatch(setAnswers(data.answers));
            dispatch(setApplicantAnswers(data.applicant, data.answers));
        }
    });

    // Applicant requested attention for live (isLiveQueue)
    socket.on('session/applicant/live/attentionneeded', data => {
        dispatch(setApplicantNeedAttention(data.session, data.applicant, data.need, data.type, data.extra));
    });

    // Applicant proctoring activity
    socket.on('applicant/proctor/active', data => {
        dispatch(setLastProctoringActivity(data.session, data.applicant, data.timestamp));
    });

    // Applicant is proctored by user (isLiveQueue)
    socket.on('session/applicant/live/proctored', data => {
        dispatch(setApplicantProctoringHandles(data.session, data.handles, data.proctor));
    });

    // Applicant flag was added (applicant side or by an administrator)
    socket.on('session/applicant/flag/updated', data => {
        dispatch(getApplicantFlagsRequest(data.session, data.applicant));
    });

    socket.on('applicant/proctor/stopped', () => {
        dispatch(stopApplicantProctoring());
    });

    socket.on('applicant/proctor/audio/toggled', data => {
        dispatch(setProctorAudioActive(data.session, data.applicant, data.proctor, data.isActive));
    });
}
